import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  container: {
    width: 148,
    marginRight: 64,
    height: 10,
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
      minWidth: 'initial',
      marginRight: 0,
      display: 'none',
    },
  },
  containerHide: {
    marginRight: 0,
  },
  containerRemove: {
    display: 'none',
  },
  line: {
    whiteSpace: 'nowrap',
    paddingLeft: 16,
    height: 32,
    borderLeft: `2px solid ${theme.palette.secondary.main}`,
    marginBottom: 20,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  lineActive: {
    borderLeft: `2px solid ${theme.palette.primary.dark}`,
  },
  crown: {
    width: 24,
    marginLeft: 8,
  },
}))

export default useStyles
